export default __webpack_public_path__ + "static/media/image-not.585b4f76.png";